import React from 'react';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {push as changeURL} from 'react-router-redux';
import {modalClose, modalChange} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';
import * as modes from '~/modules/modal/modes';
import css from './index.css';
import Button from '~/components/common/Button';

class ProfileVerify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: null,
      code: null
    }
  }
  gotoProfile = () => {
    const { isFree, goto, closePop } = this.props;
    closePop();
    isFree ? goto('/free-account') : goto('/my-account');
  }
  render() {
    const {error} = this.state;
    const { closePop } = this.props;
    if (isEmpty(this.props.context)) {
      return null;
    }
    return (
      <div className={css.popwrap}>
        <div className={css.title}>Profile Verification</div>
        <div className={css.message}>Truckloads requires carrier to verify to ensure the bidding process can actually happen.</div>
        <div className={css.btnGroup}>
          <Button  mods={['large']} onClick={closePop}>Not Now</Button>
          <Button
            mods={['large', 'action']}
            onClick= {this.gotoProfile}
          >Verify</Button>
        </div>
        
      </div>
    )
  }
}

export default connect(({account})=>{
  const { free, accountLevel} = account;
  const isFree = Number(accountLevel) <= Number(free)
  return {
    isFree
  }
}, mapDispatch({
  closePop: () => modalClose(modes.PROFILE_VERIFY),
  goto: (props, url) =>  changeURL(url),
}))(ProfileVerify);


// WEBPACK FOOTER //
// ./src/components/Popup/ProfileVerify/index.js